
import AdminRepo from "../components/admin/AdminReport";

export default function AdminReport() {
  return (
    <div>
      <AdminRepo />
    </div>
  );
}
